import { useState, useEffect, useRef } from "react";
import http from "../../Api/http";
import { useTranslation } from "react-i18next";

const ItemsSearch = ({ isOpen, onClose, onSelect }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === "ar" || i18n.language === "he";
    const [search, setSearch] = useState("");
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const inputRef = useRef();
    const debounceRef = useRef();

    // 🔍 جلب البيانات من السيرفر
    const loadItems = async (query) => {
        try {
            if (!query || query === '') {
                setItems([]);
                return;
            }
            setLoading(true);

            const res = await http.getJsonAxios(http.actions.Shipments.GetItems, { SearchText: query }, t);
            if (res.status === 200 && res.data.success) {
                if (res.data.dataObject && res.data.dataObject.length > 0) {
                    const data = res.data.dataObject;
                    setItems(data);
                }
            }
            else {
                setItems([]);
            }
        } catch (err) {
            console.error("Error fetching items:", err);
        } finally {
            setLoading(false);
        }
    };

    // ⏱ debounce
    useEffect(() => {
        clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(() => {
            loadItems(search);
        }, 400);

        return () => clearTimeout(debounceRef.current);
    }, [search]);

    // 🎯 focus للباركود
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => inputRef.current?.focus(), 100);
            loadItems(""); // أول تحميل
        }
    }, [isOpen]);

    // ⌨️ Enter للـ scanner
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && items.length === 1) {
            onSelect(items[0]);
            onCloseDialog();
        }
    };

    const onCloseDialog = () => {
        setItems([]);
        setSearch("");
        onClose();
    }

    if (!isOpen) return null;

    return (
        <div className="overlay" dir={t('dir')}>
            <div className="modal">

                <div className="relative bg-white rounded-lg p-2">
                    <h2>{t('itemSelect')}</h2>
                    {/* <button onClick={onCloseDialog}>✕</button> */}
                    <button className={isRTL ? "absolute top-2 left-2 text-xl" : "absolute top-2 right-2 text-xl"} onClick={onCloseDialog}>✖️</button>
                </div>

                <input
                    ref={inputRef}
                    type="text"
                    placeholder={`🔍 ${t('searchHint')}`}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className="search"
                />

                <div className="list">
                    {items.map((item) => (
                        <div
                            key={item.id}
                            className="item"
                            onClick={() => {
                                onSelect(item);
                                onCloseDialog();
                            }}
                        >
                            <div>
                                <strong>{item.Name}</strong>
                                <p>{item.Barcode}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            <style>{`
        .overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.4);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }

        .modal {
          background: white;
          width: 95%;
          max-width: 500px;
          height: 90%;
          max-height: 600px;
          border-radius: 12px;
          display: flex;
          flex-direction: column;
          padding: 15px;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .search {
          margin: 10px 0;
          padding: 12px;
          font-size: 16px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }

        .list {
          flex: 1;
          overflow-y: auto;
        }

        .item {
          padding: 12px;
          border-bottom: 1px solid #eee;
          cursor: pointer;
          transition: 0.2s;
        }

        .item:hover {
          background: #f5f5f5;
        }

        /* 📱 Mobile optimization */
        @media (max-width: 600px) {
          .modal {
            height: 100%;
            border-radius: 0;
          }

          .search {
            font-size: 18px;
          }

          .item {
            padding: 16px;
          }
        }
      `}</style>
        </div>
    );
}
export default ItemsSearch;